import { Button, Card, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { chunkData, getSendMailSmsMeetingUsers, getSubjectName, stripHTMLTags } from 'app/utils/appHelpers';
import { CRON_DATA, DECISION_FILE, VOTE } from 'app/utils/constants/customConstant';
import { baseFontSize, dshCardHeight, redColor } from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DshBoxTitle from '../Box/DshBoxTitle';
import LoadingPopUp from '../LoadingPopup';
import ReviewFileListTable from '../Table/ReviewFileListTable';
import { controlOfAllUserInputs } from 'api/meeting';

function AddUpdateVoteCard({ decision, index, addAfterTable, updateAfterTable, handleDelete, setVoteInputStatus, voteOfTheUser }) {

  const { authUser } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const [acceptButtonText, setAcceptButtonText] = useState("Kabul");
  const [rejectButtonText, setRejectButtonText] = useState("Ret");
  const subjectList = useSelector(state => state.subject.data || []);
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const [isDeleteButtonVisible, setIsDeleteButtonVisible] = useState(false);
  const userList = useSelector(state => state.user.data || []);
  const [agendaFileList, setAgendaFileList] = useState([]);
  const [linkList, setLinkList] = useState([]);

  const emptyVote = {
    userId: authUser.id,
    meetingId: currentMeeting.id,
    decisionId: decision.id,
    inst: authUser.inst,
    vote: 0,
    info: '',
    pdate: new Date()
  };

  const [vote, setVote] = useState(voteOfTheUser === undefined ? emptyVote : voteOfTheUser);


  useEffect(() => {
    let agendaFiles = [];
    const getAPI = async () => {
      setLoading(true);
      try {
        if (vote) {
          await buttonTextChange(vote.vote)
        }

        let data = [];
        const res = await getObjectListByPropertyApi(DECISION_FILE, "decisionId", decision.id)
        data = res.data || [];
        agendaFiles = data.filter(item => item.fileInfo === null || item.fileInfo === "")
        agendaFiles.forEach(element => {
          const user = userList.find(item => item.id === element.adminUserId);
          element.user = user;
        });
        setAgendaFileList(agendaFiles);

        let links = [];
        links = data.filter(item => item.fileInfo !== "" && item.ext === "")
        setLinkList(links)

      } catch (error) {
        console.error('Hata:', error);
      } finally {
        setLoading(false);
      }
    };
    getAPI();

  }, [decision.id]);

  const handleSave = async (type) => {

    vote.vote = type;

    try {
      if (vote.id) { // guncelleme


        let voteWithoutUser = { ...vote };
        delete voteWithoutUser.user;
        voteWithoutUser.pdate = new Date(); 
        vote.pdate = new Date();
        const result = await putUpdateObjectApi(VOTE, voteWithoutUser);
        if (result.status) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Oyunuz güncellendi.',
            showConfirmButton: false,
            timer: 1500

          });

          await buttonTextChange(type);
          setVote(vote);
          setIsDeleteButtonVisible(true);

          updateAfterTable && updateAfterTable({ ...vote })

        }


      } else { // ekleme


        const result = await postSaveObjectApi(VOTE, vote);
        if (result.status) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Oyunuz kaydedildi.',
            showConfirmButton: false,
            timer: 1500

          });
          vote.id = result.data.insertId;
          await buttonTextChange(type);
          setVote(vote);
          setIsDeleteButtonVisible(true);

          addAfterTable({ id: result.data.insertId, ...vote });
        }


      }
    } catch (error) {
      console.error('Hata:', error);
    }

    finally {


      if (vote.id !== undefined) {
        const result = await controlOfAllUserInputs(vote.meetingId, "vote");
        if (result.status) {
          if (result.data === 0) {

            // hatırlatıcı varsa silme yapılıyor
            let existingCron = await getObjectListByPropertyApi(CRON_DATA, "meetingId", vote.meetingId);
            existingCron = existingCron.data;
            if (existingCron.length > 0) {
              for (const item of existingCron) {
                await deleteObjectApi(CRON_DATA, item.id); //  cron uyeler oylamasını tamamladıgı icin silindi vote
              }
            }


            Swal.fire({
              position: 'center',
              icon: 'success',
              showConfirmButton: false,
              timer: 2000,
              title: 'Bu toplantıya ait tüm oylar tamamlandı.',
            })



          }
        }
      }

    };


  }
  const buttonTextChange = async (type) => {
    if (type === 1) {
      setAcceptButtonText("Kabul ettiniz")
      setRejectButtonText("Ret")
      setIsDeleteButtonVisible(true);

    } else if (type === 2) {
      setRejectButtonText("Reddettiniz")
      setAcceptButtonText("Kabul")
      setIsDeleteButtonVisible(true);

    } else if (type === 0) {
      setRejectButtonText("Ret")
      setAcceptButtonText("Kabul")
      setIsDeleteButtonVisible(false);

    }

  };

  const handleDeleteItem = async (vote) => {
    const result = await handleDelete(vote)
    if (result.status) {

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Oyunuz silindi.',
        showConfirmButton: false,
        timer: 1500

      });

      setVoteInputStatus(false)
      setVote(emptyVote)
      await buttonTextChange(0)
      setIsDeleteButtonVisible(false)
    }
  };

  const handleChange = name => (e) => {

    setVote({
      ...vote,
      [name]: e.target.value
    })
  }


  const secondTitle = vote.id !== undefined ? (vote.vote === 1 ? "Kabul ettiniz" : vote.vote === 2 ? "Reddettiniz" : "") : "Henüz Oy Vermediniz";

  // Dosyaları grupla
  const groupedData = chunkData(agendaFileList, 5);
  const groupedDataLink = chunkData(linkList, 5);

  return (
    <>
      <LoadingPopUp open={loading} />
      {!loading && (
        <Card
          key={index}
          sx={{
            m: 0,
            p: '10px',
            marginBottom: 0,
            minHeight: `${dshCardHeight}`,
            // height: `${dshPreviousCardHeight}`,
          }}
        >
          <DshBoxTitle color="primary" secondTitle={secondTitle} title={`Gündem Maddesi ${decision.decisionNo}` + " / " + getSubjectName(decision.subjectId, subjectList)} />


          <Grid container marginY={2} spacing={1} rowSpacing={1}>
            <Grid item xs={12} md={12} lg={12} >
              <span style={{ fontSize: baseFontSize }}>
                {decision.agenda.replace(/<[^>]*>?/g, "")}
              </span>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Typography
                variant={"h6"}
                color={`${redColor}`}
                sx={{ fontSize: baseFontSize }}
              >
                Karar
              </Typography>
              <span style={{ fontSize: baseFontSize, whiteSpace: "pre-line" }}>
                {/* {decision.decision.replace(/<[^>]*>?/g, "")} */}
                {stripHTMLTags(decision.decision)}
              </span>
            </Grid>

            <Grid
              container
              marginY={2}
              marginX={0}
              spacing={1}
              rowSpacing={1}
            >
              <Grid item xs={10} md={10} lg={10}>
                <TextField
                  variant="outlined"
                  label="Varsa yorum ya da ret gerekçenizi yazınız..."
                  multiline
                  fullWidth
                  rows={4}
                  value={vote.info}
                  onChange={handleChange("info")}
                  InputProps={{
                    style: { fontSize: baseFontSize },
                  }}
                  InputLabelProps={{
                    style: { fontSize: baseFontSize },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={6}
                md={3}
                lg={2}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  size='small'
                  color="success"
                  onClick={() => handleSave(1)}
                  style={{
                    maxWidth: "70%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: baseFontSize,
                    marginBottom: "5px",
                  }}
                >
                  {acceptButtonText}
                </Button>




                <Button
                  variant="contained"
                  fullWidth
                  size="small" // Prop olarak ekleniyor
                  color="error"
                  onClick={() => handleSave(2)}
                  style={{
                    maxWidth: "70%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: baseFontSize,
                    marginBottom: "5px",
                  }}
                >
                  {rejectButtonText}
                </Button>


                {isDeleteButtonVisible && (
                  <Button
                    variant="contained"
                    color="warning"
                    size='small'
                    fullWidth
                    onClick={() => handleDeleteItem(vote)}
                    style={{
                      maxWidth: "70%",
                      whiteSpace: "nowrap",
                      size: 'small',

                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: baseFontSize,
                    }}
                  >
                    Sil
                  </Button>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <ReviewFileListTable groupedData={groupedData} borderType={false} />
            </Grid>

            {groupedDataLink.length > 0 && (
              <Grid item xs={12} md={12} lg={12}>
                <ReviewFileListTable groupedData={groupedDataLink} borderType={false} dataType='link' />
              </Grid>
            )}
          </Grid>
        </Card>
      )}
    </>
  );
}
export default AddUpdateVoteCard;

